import { Form } from 'antd';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BannerProvider } from './context';
import { useNavigate } from 'react-router-dom';
import Customize from './Customize';
import Header from './Header';
import Preview from './Preview';
import useQuery from '../../util/useQuery';
import useNotify from '../../context/Notification/useNotify';
import CustomizeBannerService from '../../services/CustomizeBanner.service';
import IconPleaseSelectDomain from '../../assets/Images/icons/icon-please-select-domain';
import ModalDiscardChanges from '../../components/Shared/modal/discardChanges';
import { useBlocker } from '../../util/usePrompt';
const CustomizeBanner = () => {
    const { t } = useTranslation();
    const params = useQuery();

    const [values, setValues] = useState();
    const [form] = Form.useForm();
    const [domainId, setDomainId] = useState();

    const [customize, setCustomize] = useState([]);
    const [headerDetail, setHeaderDetail] = useState();

    const [logoId, setLogoId] = useState();
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const navigate = useNavigate();
    const notify = useNotify();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };
    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFinish = async (e) => {
        if (!params.get('tab') || params.get('tab') === '1') {
            //Customize Banner
            const item = {
                ...values,
                ...e,
            };
            if (
                !item?.useDefaultIcon &&
                !logoId &&
                document.querySelector('.ant-form-item-iconCookieId')
            ) {
                document
                    .querySelector('.ant-form-item-iconCookieId')
                    .scrollIntoView({ behavior: 'smooth' });
                form.setFields([
                    {
                        name: 'iconCookieId',
                        errors: [t('errorText.requiredField')],
                    },
                ]);
                return;
            }

            const payload = {
                customizeContent: {
                    ...item?.customizeContent,
                    isDisplayCookiePolicy: item.isDisplayCookiePolicy,
                    isDisplayPrivacyPolicy: item.isDisplayPrivacyPolicy,
                    cookiePolicyUrlTh: item?.cookiePolicyUrlTh,
                    cookiePolicyUrlEn: item?.cookiePolicyUrlEn,
                    privacyPolicyUrlTh: item?.privacyPolicyUrlTh,
                    privacyPolicyUrlEn: item?.privacyPolicyUrlEn,
                    hyperLinkDisplayCookieNameEn:
                        values.hyperLinkDisplayCookieNameEn,
                    hyperLinkDisplayCookieNameTh:
                        values.hyperLinkDisplayCookieNameTh,
                    hyperLinkDisplayPrivacyNameEn:
                        values.hyperLinkDisplayPrivacyNameEn,
                    hyperLinkDisplayPrivacyNameTh:
                        values.hyperLinkDisplayPrivacyNameTh,
                },
                customizeStyle: {
                    hiddenLogo: item?.hiddenLogo || false,
                    companyLogoId: item?.companyLogoId || null,
                    fontFamily: item?.fontFamily || null,
                    header: item?.header || null,
                    description: item?.description || null,
                    powerBy: item?.powerBy || null,
                    hyperlink: item?.hyperlink || null,
                    button: item?.button || null,
                    backgroundThemeColor: item?.backgroundThemeColor || null,
                    buttonThemeColor: item?.buttonThemeColor || null,
                    acceptAllTh: item?.acceptAllTh || null,
                    acceptAllEn: item?.acceptAllEn || null,
                    changePreferenceTh: item?.changePreferenceTh || null,
                    changePreferenceEn: item?.changePreferenceEn || null,
                    rejectedAll: item?.rejectedAll || false,
                    rejectedAllTh: item?.rejectedAllTh || null,
                    rejectedAllEn: item?.rejectedAllEn || null,
                    position: item?.position || null,
                    closeable: item?.closeable || false,
                    alwaysDisplay: item?.alwaysDisplay || false,
                    positionIcon: item?.positionIcon || null,
                    useDefaultIcon: item?.useDefaultIcon,
                    iconColor: item?.iconColor || null,
                    iconBackground: item?.iconBackground || null,
                    iconCookieId: logoId || null,
                    autoBlock3rdParty: item?.autoBlock3rdParty || false,
                },
            };
            try {
                const { data } =
                    await CustomizeBannerService.updateCustomizeBanner(
                        domainId,
                        payload
                    );
                if (data?.resultCode === 1) {
                    getHeaderDetail();
                    getCustomizeBanner();
                    setChange(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Save data successfully'),
                    });
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        } else {
            //Setting Peference
            const payload = {
                domainId: domainId,
                customizeStyle: {
                    fontFamily: values?.fontFamilyPreference,
                    header: values?.headerPreference,
                    cookieCategoryName: values?.cookieCategoryNamePreference,
                    cookieCategoryDescription:
                        values?.cookieCategoryDescriptionPreference,
                    link: values?.linkPreference,
                    button: values?.buttonPreference,
                    backgroundThemeColor:
                        values?.backgroundThemeColorPreference,
                    backgroundCardColor: values?.backgroundCardColorPreference,
                    buttonThemeColor: values?.buttonThemeColorPreference,
                },
            };
            try {
                const { data } =
                    await CustomizeBannerService.updateCustomizeSettingPeference(
                        payload
                    );
                if (data?.resultCode === 1) {
                    getHeaderDetail();
                    getCustomizeSettingPeference();
                    setChange(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                        timeOut: 120000,
                        closeable: true,
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                    timeOut: 120000,
                    closeable: true,
                });
            }
        }
    };

    const onValuesChange = async (_, allValues) => {
        setValues({ ...values, ...allValues });
    };

    const onFinishFailed = async ({ _, errorFields }) => {
        console.log(errorFields);
    };

    useEffect(() => {
        if (domainId) {
            if (!params.get('tab') || params.get('tab') === '1') {
                getCustomizeBanner();
                getHeaderDetail();
            } else {
                getCustomizeSettingPeference();
                getHeaderDetail();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainId, params]);

    const getHeaderDetail = async () => {
        try {
            const { data } = await CustomizeBannerService.getHeaderDetail(
                domainId
            );
            const item = data?.resultData;
            setHeaderDetail(item);
        } catch (err) {
            setHeaderDetail();
            console.log(err);
        }
    };

    const getCustomizeBanner = async () => {
        try {
            const { data } = await CustomizeBannerService.getCustomizeBanner(
                domainId
            );
            if (data?.resultData) {
                const resultData = data?.resultData;
                const banner = {
                    isUsedInventory: resultData.isUsedInventory,
                    customizeContent: {
                        titleTh: resultData?.customizeContent?.titleTh,
                        titleEn: resultData?.customizeContent?.titleEn,
                        contentTh: resultData?.customizeContent?.contentTh,
                        contentEn: resultData?.customizeContent?.contentEn,
                    },
                    isDisplayCookiePolicy:
                        resultData?.customizeContent.isDisplayCookiePolicy,
                    isDisplayPrivacyPolicy:
                        resultData?.customizeContent.isDisplayPrivacyPolicy,
                    cookiePolicyUrlTh:
                        resultData?.customizeContent?.cookiePolicyUrlTh,
                    cookiePolicyUrlEn:
                        resultData?.customizeContent?.cookiePolicyUrlEn,
                    privacyPolicyUrlTh:
                        resultData?.customizeContent?.privacyPolicyUrlTh,
                    privacyPolicyUrlEn:
                        resultData?.customizeContent?.privacyPolicyUrlEn,
                    hyperLinkDisplayCookieNameEn:
                        resultData?.customizeContent
                            .hyperLinkDisplayCookieNameEn,
                    hyperLinkDisplayCookieNameTh:
                        resultData?.customizeContent
                            .hyperLinkDisplayCookieNameTh,
                    hyperLinkDisplayPrivacyNameEn:
                        resultData?.customizeContent
                            .hyperLinkDisplayPrivacyNameEn,
                    hyperLinkDisplayPrivacyNameTh:
                        resultData?.customizeContent
                            .hyperLinkDisplayPrivacyNameTh,
                    hiddenLogo: resultData?.customizeStyle?.hiddenLogo,
                    companyLogoId: resultData?.customizeStyle?.companyLogoId,
                    fontFamily: resultData?.customizeStyle?.fontFamily,
                    header: {
                        fontSize:
                            resultData?.customizeStyle?.header?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.header?.color,
                    },
                    description: {
                        fontSize:
                            resultData?.customizeStyle?.description?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.description?.color,
                    },
                    powerBy: {
                        fontSize:
                            resultData?.customizeStyle?.powerBy?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.powerBy?.color,
                    },
                    hyperlink: {
                        fontSize:
                            resultData?.customizeStyle?.hyperlink?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.hyperlink?.color,
                    },
                    button: {
                        fontSize:
                            resultData?.customizeStyle?.button?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.button?.color,
                    },
                    backgroundThemeColor:
                        resultData?.customizeStyle?.backgroundThemeColor,
                    buttonThemeColor:
                        resultData?.customizeStyle?.buttonThemeColor,
                    acceptAllTh: resultData?.customizeStyle?.acceptAllTh,
                    acceptAllEn: resultData?.customizeStyle?.acceptAllEn,
                    changePreferenceTh:
                        resultData?.customizeStyle?.changePreferenceTh,
                    changePreferenceEn:
                        resultData?.customizeStyle?.changePreferenceEn,
                    rejectedAll: resultData?.customizeStyle?.rejectedAll,
                    rejectedAllTh: resultData?.customizeStyle?.rejectedAllTh,
                    rejectedAllEn: resultData?.customizeStyle?.rejectedAllEn,
                    position: resultData?.customizeStyle?.position,
                    closeable: resultData?.customizeStyle?.closeable,
                    alwaysDisplay: resultData?.customizeStyle?.alwaysDisplay,
                    positionIcon: resultData?.customizeStyle?.positionIcon,

                    useDefaultIcon: resultData?.customizeStyle?.useDefaultIcon,
                    iconColor: resultData?.customizeStyle?.iconColor,
                    iconBackground: resultData?.customizeStyle?.iconBackground,
                    iconCookieId: resultData?.customizeStyle?.iconCookieId,
                };
                setCustomize(resultData);
                form.setFieldsValue({
                    ...banner,
                });
                console.log(banner);
                setValues({ ...banner });
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getCustomizeSettingPeference = async (banner) => {
        try {
            const { data } =
                await CustomizeBannerService.getCustomizeSettingPeference(
                    domainId
                );
            if (data?.resultData) {
                const resultData = data?.resultData;
                const items = {
                    ...banner,
                    fontFamilyPreference:
                        resultData?.customizeStyle?.fontFamily,
                    headerPreference: {
                        fontSize:
                            resultData?.customizeStyle?.header?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.header?.color,
                    },
                    cookieCategoryNamePreference: {
                        fontSize:
                            resultData?.customizeStyle?.cookieCategoryName?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.cookieCategoryName
                            ?.color,
                    },
                    cookieCategoryDescriptionPreference: {
                        fontSize:
                            resultData?.customizeStyle?.cookieCategoryDescription?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle
                            ?.cookieCategoryDescription?.color,
                    },
                    linkPreference: {
                        fontSize:
                            resultData?.customizeStyle?.link?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.link?.color,
                    },
                    buttonPreference: {
                        fontSize:
                            resultData?.customizeStyle?.button?.fontSize?.replace(
                                /\s/g,
                                ''
                            ),
                        color: resultData?.customizeStyle?.button?.color,
                    },
                    backgroundThemeColorPreference:
                        resultData?.customizeStyle?.backgroundThemeColor,
                    backgroundCardColorPreference:
                        resultData?.customizeStyle?.backgroundCardColor,
                    buttonThemeColorPreference:
                        resultData?.customizeStyle?.buttonThemeColor,
                };
                // console.log('getCustomizeSettingPeference :: ', data?.resultData)
                setCustomize(resultData);
                console.log(items);
                form.setFieldsValue({
                    ...items,
                });
                setValues({ ...items });
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <BannerProvider value={values}>
                <div className="title flex">{t('Cookie Banner')}</div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">
                        {t('Cookie Management')} /{' '}
                    </span>
                    <span className="text-sm text-gray-400">
                        {t('Cookie Banner')}
                    </span>
                </div>
                <Header
                    getHeaderDetail={getHeaderDetail}
                    headerDetail={headerDetail}
                    setDomainId={setDomainId}
                    domainId={domainId}
                    customize={customize}
                    onFinish={onFinish}
                    form={form}
                    setChange={setChange}
                />

                {domainId ? (
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        form={form}
                        onValuesChange={onValuesChange}
                        onFinishFailed={onFinishFailed}
                        onFinish={onFinish}
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                        layout="vertical"
                        initialValues={customize}
                    >
                        <div className="grid grid-cols-4 gap-4">
                            <Preview domainId={domainId} values={values} />
                            <Customize form={form} setLogoId={setLogoId} />
                        </div>
                    </Form>
                ) : (
                    <div className="flex flex-col items-center py-20">
                        <IconPleaseSelectDomain />
                        <div className="text-[14px] text-[#65707A]">
                            {t('COOKIE.PleaseSelectDomainBeforeCustomize')}
                        </div>
                    </div>
                )}
            </BannerProvider>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </>
    );
};

export { CustomizeBanner };
